export default __webpack_public_path__ + "static/media/MARBLES-THAT-FIRE-YOUR-IMAGINATION.9f16095d.jpg";